import Model from '../Model'
import QueryBuilder from '../QueryBuilder'
import { Builder } from '../Builder'

type Callback = () => any

class Relationship {
    protected _relativeBuilder: Builder & QueryBuilder;
    protected _relativeModel: Model;
    protected _currentModel: Model;
    static constraints: boolean = true

    constructor(relativeBuilder: Builder & QueryBuilder, currentModel: Model)
	{
		this._relativeBuilder = relativeBuilder

		this._currentModel = currentModel

		this._relativeModel = (relativeBuilder as any).getModel()
    }

    static noConstraints(callback: Callback): ReturnType<Callback> {
		const previous = this.constraints;

		this.constraints = false;

		// When resetting the relation where clause, we want to shift the first element
		// off of the bindings, leaving only the constraints that the developers put
		// as "extra" on the relationships, and not original relation constraints.
		const results = callback();

		this.constraints = previous;

		return results;
	}

    protected getRelativeBuilder(): Builder & QueryBuilder {

        return this._relativeBuilder
    }

    protected getRelativeModel(): Model {

        return this._relativeModel
    }

    protected getCurrentModel(): Model {
        
        return this._currentModel
    }

    public excludeDuplicate(ids: number[]) {
        return ids.reduce<number[]>((result, item) => {
            if(!result.includes(item)) {
                result.push(item)
            }
            return result
        }, [])
    }

    public getModelId(model: Model) {
        return model.getPrimaryKeyId() || model[model.getForeignKey() as keyof Model] || 0
    }

    public getModelsId(currentModels: Model[]): number[] {

        return currentModels.map((model: Model) => {

            return this.getModelId(model)
        })
    }
    
    public __get(method: string): any {

        const builder = this.getRelativeBuilder()

		if (builder[method as keyof Builder]) {

			return (...parameters: any[]) => {

				const result = (builder as any)[method](...parameters)

				if (result === builder) return this;

				return result;

            }

        } else {

            throw new Error(`${this.getRelativeModel().getConstructor().name}.${method} does not exists`)
            
		}
	}
}

export default Relationship